import { Link } from 'react-router-dom';
import { apps } from '../utils/dataModel';
import { trackEvent } from '../utils/analytics';

const AppsSection = () => {
  return (
    <section className="services">
      <div className="services-container">
        <div className="services-header">
          <h2>Apps I've Built</h2>
          <p className="services-subtitle">
            Software I designed, built, and still maintain. Both run on your own machine,
            and both are bought once rather than rented.
          </p>
        </div>

        <div className="services-grid">
          {apps.map((app) => (
            <div key={app.id} className="service-card">
              {/* Deliberately not .service-icon/.service-image: those force a
                  100%-wide, 200px-tall cover crop built for the landscape service
                  photos, which massively upscales a square app logo. */}
              <div className="app-logo-plate">
                <img
                  src={app.logo}
                  alt={`${app.name} logo`}
                  className="app-logo-img"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <div className="service-content">
                <h3>{app.name}</h3>
                <p className="service-description">{app.description}</p>
                <p className="service-projects">{app.platforms.join(' · ')}</p>
                <a
                  href={app.cta.url}
                  className="service-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEvent('app_cta_click', {
                    app_id: app.id,
                    app_name: app.name,
                    cta: app.cta.label,
                    location: 'homepage'
                  })}
                >
                  {app.cta.label}
                  {' →'}
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="services-footer">
          <Link to="/apps" className="btn btn-secondary">More about both apps</Link>
        </div>
      </div>
    </section>
  );
};

export default AppsSection;
